(() => {
  if (window.__alShippingConsistencyInitialized) return;
  const configNode = document.getElementById('ArtemShippingConsistency');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  window.__alShippingConsistencyInitialized = true;
  const posterOnly = Boolean(config.posterOnly);
  const verifiedWorld = Boolean(config.verifiedWorld);
  const nonEurope = Boolean(config.nonEurope);
  const copy = Object.fromEntries(
    Object.entries(config.copy || {}).map(([key, value]) => [
      key,
      typeof value === 'string' ? value.trim() : value
    ])
  );

  const fold = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  const returnTerms = ['retour', 'return', 'ruckgabe', 'devolucion', 'devolu', 'reso', 'retourner', 'returnering', 'palaut', 'zwrot', 'retur', '返品', '반품'];
  const shippingTerms = ['livraison', 'delivery', 'liefer', 'entrega', 'consegna', 'levering', 'dostaw', 'toimitus', 'frakt', 'forsend', '配送', 'お届け', '배송'];
  const materialTerms = ['100% polyester', '100 % polyester', '285g/m', '285 g/m', 'polyester (285', 'ポリエステル（285', '폴리에스터(285'];
  const europeTerms = ['throughout europe', 'partout en europe', 'europe', 'europa', 'in heel europa', 'w całej europie', 'inom europa', 'i hele europa', 'euroopassa', 'ヨーロッパ', '유럽'];
  const productionTerms = ['production', 'fabric', 'made', 'imprim', '製作', '受注生産', '제작'];
  const includesAny = (text, terms) => terms.some((term) => text.includes(fold(term)));

  const replaceRow = (row, title, body, replaceAllContent = false) => {
    const heading = row.querySelector('.iwtc-row__heading, [class*="iwtc-row__heading"]');
    const content = row.querySelector('.icon-with-text-column__text, [class*="iwtc-row__content"] .rte, .rte');
    const paragraph = content?.querySelector('p');
    if (heading && heading.textContent.trim() !== title) heading.textContent = title;
    if (replaceAllContent && content) {
      if (fold(content.textContent) === fold(body)) return;
      const replacement = document.createElement('p');
      replacement.textContent = body;
      content.replaceChildren(replacement);
      return;
    }
    if (paragraph && paragraph.textContent.trim() !== body) paragraph.textContent = body;
  };

  const enforce = () => {
    document.querySelectorAll('.icon-with-text-column, [class*="icon-with-text-column"]').forEach((row) => {
      const text = fold(row.textContent);
      const hasReturnIcon = Boolean(row.querySelector('.icon-back-30, [class*="icon-back-30"]'));
      if (hasReturnIcon || (includesAny(text, returnTerms) && text.includes('30'))) {
        replaceRow(row, copy.returnsTitle, copy.returnsBody);
        return;
      }
      if (posterOnly && includesAny(text, shippingTerms) && (text.includes('3') || includesAny(text, europeTerms))) {
        replaceRow(row, copy.deliveryTitle, `${copy.posterEta}. ${copy.posterAvailability}`, true);
        return;
      }
      if (nonEurope && includesAny(text, shippingTerms) && (text.includes('3') || includesAny(text, europeTerms))) {
        const destinationCopy = verifiedWorld
          ? `${copy.worldTiming} ${copy.worldAvailability}`
          : `${copy.standardEta}. ${copy.standardAvailability}`;
        replaceRow(row, copy.deliveryTitle, destinationCopy, true);
      }
    });

    if (posterOnly || nonEurope) {
      document.querySelectorAll('p, li').forEach((element) => {
        const text = fold(element.textContent);
        if (verifiedWorld && includesAny(text, materialTerms)) {
          element.textContent = copy.worldMaterial;
        } else if (includesAny(text, europeTerms) && includesAny(text, productionTerms)) {
          element.textContent = posterOnly
            ? `${copy.posterEta}. ${copy.posterAvailability}`
            : verifiedWorld
              ? copy.worldTiming
              : `${copy.standardEta}. ${copy.standardAvailability}`;
        }
      });
    }
  };

  const start = () => {
    enforce();
    if (!posterOnly && !nonEurope) return;
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; enforce(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
